/**
 *
 * TopicItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import Card from 'components/Card';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import ClassNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import Badge from 'components/Badge';
import Mixpanel from 'utils/mixpanelService';
import Editors from 'containers/Topic/components/HeaderEditors';
import ArrowRight from './images/arrow-right.svg';

const styles = theme => ({
  link: {
    textDecoration: 'none',
    position: 'relative',
  },
  content: {
    display: 'flex',
    padding: '0 15px',
  },
  topic: {
    marginTop: 20,
    display: '-webkit-box',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 20 /* Fallback for non-webkit */,
    marginBottom: 5,
  },
  title: {
    marginTop: 10,
    marginBottom: 3,
    display: '-webkit-box',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 20 /* Fallback for non-webkit */,
  },
  divider: {
    width: 30,
    height: 3,
    margin: '15px 0',
    background: '#C7DEE8',
  },
  answerHeader: {
    ...theme.typography.pSmallBold,
  },
  answer: {
    marginBottom: 5,
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  btnLink: {
    padding: 12,
    display: 'flex',
    alignItems: 'center',
    width: 116,
    background: '#fff',
    height: 34,
    position: 'relative',
    fontSize: 15,
    color: theme.palette.text.secondary,
    marginTop: 15,
    borderRadius: 2,
    textDecoration: 'none',
  },
  arrowIcon: {
    position: 'absolute',
    right: 10,
    marginTop: 1,
  },
});

class TopicItem extends React.PureComponent {
  redirect = () => {
    const {
      data: { title },
      type = 'topic',
      location,
    } = this.props;
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: title,
      type,
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
    });
  };

  getTotalResources = facets => {
    let total = 0;
    const hits = _get(facets, 'facetHits');
    hits.forEach(hit => {
      if (hit.value !== 'People') {
        total += hit.count;
      }
    });
    return total;
  };

  render() {
    const {
      classes,
      data,
      data: { item, facets },
      type = 'topic',
      background,
      height,
    } = this.props;
    if (_isEmpty(data)) return null;
    const { title, slug, quickTake, editors = [] } = item.fields;
    // react-router issue
    const finalRoute = `/topics/${slug}`;
    const totalResources = this.getTotalResources(facets);
    return (
      <Link to={finalRoute} className={classes.link} onClick={this.redirect}>
        <Card
          height={height}
          background={background}
          borderColor="transparent"
          padding={0}
        >
          <div className={ClassNames(classes.desktopWrapper)}>
            <Grid container justify="flex-start">
              <Grid item xs={12} className={classes.badgeWrapper}>
                <Badge type={type} />
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Typography
                  variant="h6"
                  color="textPrimary"
                  align="left"
                  className={classes.title}
                >
                  {title}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Typography variant="overline" color="textPrimary" align="left">
                  {totalResources}{' '}
                  {totalResources > 1 ? 'Resources' : 'Resource'}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Editors data={editors} />
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <span className={classes.divider} />
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <div className={classes.answer}>
                  <RichTextReactRenderer
                    data={quickTake}
                    type="title"
                    contentType="topic"
                  />
                </div>
              </Grid>
              <Grid item xs={12} className={classes.content}>
                <Link
                  to={finalRoute}
                  className={classes.btnLink}
                  onClick={this.redirect}
                >
                  Read more
                  <img
                    src={ArrowRight}
                    alt="Read more"
                    className={classes.arrowIcon}
                  />
                </Link>
              </Grid>
            </Grid>
          </div>
        </Card>
      </Link>
    );
  }
}
TopicItem.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  type: PropTypes.string,
  height: PropTypes.number,
  location: PropTypes.object,
  background: PropTypes.string,
};

TopicItem.defaultProps = {
  height: 348,
  background: '#E8F1F5',
};

export default compose(
  withRouter,
  withStyles(styles),
)(TopicItem);
